import { render, staticRenderFns } from "./internalResultInfo.vue?vue&type=template&id=10d5b8e2"
import script from "./internalResultInfo.vue?vue&type=script&lang=js"
export * from "./internalResultInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10d5b8e2')) {
      api.createRecord('10d5b8e2', component.options)
    } else {
      api.reload('10d5b8e2', component.options)
    }
    module.hot.accept("./internalResultInfo.vue?vue&type=template&id=10d5b8e2", function () {
      api.rerender('10d5b8e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/internalAudit/temp2/internalResultInfo.vue"
export default component.exports